/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SiegeSocialHistoryGridDto } from './SiegeSocialHistoryGridDto';
import {
    SiegeSocialHistoryGridDtoFromJSON,
    SiegeSocialHistoryGridDtoFromJSONTyped,
    SiegeSocialHistoryGridDtoToJSON,
} from './SiegeSocialHistoryGridDto';

/**
 * 
 * @export
 * @interface SiegeSocialHistoryGridDtoPaginatedResults
 */
export interface SiegeSocialHistoryGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialHistoryGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SiegeSocialHistoryGridDto>}
     * @memberof SiegeSocialHistoryGridDtoPaginatedResults
     */
    results?: Array<SiegeSocialHistoryGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SiegeSocialHistoryGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SiegeSocialHistoryGridDtoPaginatedResults interface.
 */
export function instanceOfSiegeSocialHistoryGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeSocialHistoryGridDtoPaginatedResultsFromJSON(json: any): SiegeSocialHistoryGridDtoPaginatedResults {
    return SiegeSocialHistoryGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SiegeSocialHistoryGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeSocialHistoryGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SiegeSocialHistoryGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SiegeSocialHistoryGridDtoPaginatedResultsToJSON(value?: SiegeSocialHistoryGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SiegeSocialHistoryGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

